<template>
  <div class="page">
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="back()">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
      </div>
      <div class="page_top_title">
        <span class="page_top_title_txt">完善信息</span>
        <img class="page_top_title_img" src="../../../../assets/house/property/6／6.png">
      </div>
      <span class="page_top_tip">完善小区信息后才可使用物业功能</span>
    </div>
    <div class="list">
      <div class="list_item">小区：阳光城上府1区1幢3单元1101</div>
      <div class="list_item">身份：租客</div>
      <div class="list_item">性别：男</div>
      <div class="list_item">手机：13874843343</div>
      <div class="list_item" @click="fill(1)">
        <span>姓名：</span>
        <span :class="[name == ''?'list_item_input_none':'']">{{name || '请输入真实姓名'}}</span>
      </div>
      <div class="list_item" @click="fill(2)">
        <span>租期：</span>
        <span :class="[rentDate == ''?'list_item_input_none':'']">{{rentDate || '请选择'}}</span>
      </div>
    </div>
    <div class="btn" @click="submit">提交</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        name: '',
        rentDate: ''
      }
    },
    methods: {
      fill(type) {
        if (type == 1) {
          this.name = '销巴房产'
        }
        if (type == 2) {
          this.rentDate = '2022-01-01至2023-01-01'
        }
      },
      submit() {
        this.$router.push('/house/property/propertyIndex')
      },
      back() {
        this.$router.go(-1);
      },
    },
  }
</script>

<style lang="less" scoped>
  .page {
    padding-bottom: 30px;
  }

  .page_top {
    height: 181px;
    background: url('../../../../assets/house/property/binding_bg.png') no-repeat right top;
  }

  .sechout {
    height: 44px;
    padding: 15px 15px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .page_top_title {
    padding-left: 30px;
    padding-right: 20px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .page_top_title_txt {
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
  }

  .page_top_title_img {
    width: 54px;
  }

  .page_top_tip {
    padding-left: 30px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .list {
    // height: 500px;
    padding: 0 16px;
    padding-top: 15px;
    overflow-y: scroll;
  }

  .list_item {
    height: 50px;
    margin-bottom: 12px;
    padding-left: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #222325;
    line-height: 21px;
    background-color: #F8F8F8;
    display: flex;
    align-items: center;
  }

  .list_item_input_none {
    color: #B3B9BF;
  }

  .btn {
    margin: 0 16px;
    height: 48px;
    background: #26C165;
    border-radius: 10px;
    margin-top: 30px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 48px;
  }
</style>